import { useContext } from 'react';
import MessageContext from '../context/messageContext';

/**
 * useMsgContext is a convenience hook to access the message context
 */
export default function useMsgContext() {
  return useContext(MessageContext);
}
